import { formatInTimeZone } from "date-fns-tz";

const IST_TIMEZONE = "Asia/Kolkata";

export function getFormatedDate(date?: Date | string) {
  if (date) {
    return formatInTimeZone(date, IST_TIMEZONE, "yyyy-MM-dd HH:mm:ss.S");
  }

  const currentDate = new Date();
  return formatInTimeZone(currentDate, IST_TIMEZONE, "yyyy-MM-dd HH:mm:ss.S");
}

export const getCurrentYear = (): number => {
  const currentDate = new Date();
  return currentDate.getFullYear();
};
